import { render } from "./NavBottom.vue?vue&type=template&id=70754176&scoped=true"
import script from "./NavBottom.vue?vue&type=script&lang=js"
export * from "./NavBottom.vue?vue&type=script&lang=js"

import "./NavBottom.vue?vue&type=style&index=0&id=70754176&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70754176"]])

export default __exports__